<template>
    <form autocomplete="off" class="w-full relative mb-2">
        <input autocomplete="false" name="hidden" type="text" style="display:none;">
        <Field field_name="Cerca posizione">
            <div class="flex items-center gap-2">
                <div class="flex items-center relative w-1/3">
                    <input v-model="address" @input="onSearchLocation" type="text" placeholder="Cerca"
                           class="p-7px bg-next-gray-md-dark hover:bg-white w-full pr-1.5">
                    <i @click="clear" v-show="address || risultati.length" class="cursor-pointer absolute icon-croce rotate-45 right-1"></i>
                </div>
                <div class="w-2/3 flex items-center">
                    <slot name="actual" v-bind:actual="actual"></slot>
                    <ConfirmDelete position="left" v-show="placeId"
                                   @cancella="$emit('remove')" class="pl-3">
                    </ConfirmDelete>
                </div>
            </div>
        </Field>
        <ul class="absolute z-10 bg-white shadow min-w-80">
            <li class="cursor-pointer border-b px-2 py-1 hover:bg-next-light-gray"
                v-show="!risultati.length && address.length">Nessun risultato trovato
            </li>
            <li class="cursor-pointer border-b px-2 py-1 hover:bg-next-light-gray" @click="chose(risultato)"
                v-for="risultato in risultati" :key="risultato.place_id">{{ risultato.formatted_address }}
            </li>
        </ul>
    </form>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {Loader} from "@googlemaps/js-api-loader";
import GMap from "@/components/Address/GMap.vue";
import Field from "@/components/Field.vue";
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import gMapLoader from "@/types";

@Options({
    name: 'AddressAutocomplete',
    components: {
        ConfirmDelete,
        Field,
        GMap,
    },
    emits: ['chose', 'remove'],
    props: {
        marker: {
            type: Array,
            default: () => []
        },
        gaddress: {
            type: Object,
            default: () => ({})
        },
        placeId: {
            type: String,
            required: false
        },
        risultati: {
            type: Array,
            default: () => []
        },
        actual: {
            type: Object,
            required: false
        },
    },
})
export default class AddressAutocomplete extends Vue {
    address = '';
    gaddress!: any;
    map!: any;
    geocoder!: any;
    placeId!: string;
    timeout: null | number = null;
    risultati!: any[];
    actual!: any;

    async mounted() {
        const {Geocoder} = await gMapLoader.importLibrary("geocoding");
        this.geocoder = new Geocoder();
    }

    emptyResults() {
        this.$emit('update:risultati', [])
    }

    decodeAddress(address: string) {
        this.geocoder.geocode({
            address: address
        }).then((res: any) => {
            this.$emit('update:risultati', res.results)
        }).catch((res: any) => {
            switch (res.code) {
                case 'ZERO_RESULTS':
                    this.emptyResults()
                    break;
                case 'REQUEST_DENIED':
                    console.log('REQUEST_DENIED')
                    break;
                case 'INVALID_REQUEST':
                    console.log('INVALID_REQUEST')
                    break;
                case 'UNKNOWN_ERROR':
                    console.log('UNKNOWN_ERROR')
                    break;
                default:
                    console.log(res.code)
            }
        })
    }

    onSearchLocation() {
        if (this.timeout) {
            clearTimeout(this.timeout)
            this.timeout = 0
        }
        this.timeout = setTimeout(() => {
            this.decodeAddress(this.address)
        }, 500)
    }

    clear(){
        this.address = ''
        this.emptyResults()
    }

    chose(result: any) {
        this.$emit('chose', result)
        this.emptyResults()
        this.address = ''
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
